import { memo, useState } from "react";
import { Smile } from "lucide-react";

const QUICK_REACTIONS = ["❤️", "😂", "😮", "😢", "👍", "🔥"];

interface ReactionPickerProps {
  onSelectReaction: (emoji: string) => void;
  isOwnMessage: boolean;
}

const ReactionPicker = memo(({ onSelectReaction, isOwnMessage }: ReactionPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (emoji: string) => {
    onSelectReaction(emoji);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-1 rounded-full hover:bg-muted/50 opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <Smile className="w-4 h-4 text-muted-foreground" />
      </button>
      
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div 
            className={`absolute z-20 bottom-full mb-1 flex gap-1 bg-card border border-border rounded-full px-2 py-1 shadow-lg ${
              isOwnMessage ? "right-0" : "left-0"
            }`}
          >
            {QUICK_REACTIONS.map((emoji) => (
              <button
                key={emoji}
                onClick={() => handleSelect(emoji)}
                className="text-lg hover:scale-125 transition-transform"
              >
                {emoji}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
});

ReactionPicker.displayName = "ReactionPicker";

export default ReactionPicker;
